import { useState } from 'react';
import { Link } from 'react-router-dom';
import { passwordResetAPI } from '../utils/api';

const LogoIc = () => (
  <svg width="48" height="48" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Q-Lana TMS">
    <rect width="40" height="40" rx="9" fill="#1A2F5E"/>
    <line x1="9" y1="13" x2="27" y2="13" stroke="white" strokeWidth="3" strokeLinecap="round"/>
    <line x1="9" y1="20" x2="27" y2="20" stroke="white" strokeWidth="3" strokeLinecap="round"/>
    <line x1="9" y1="27" x2="20" y2="27" stroke="white" strokeWidth="3" strokeLinecap="round"/>
    <polyline points="21,24 25,28 33,18" stroke="#5CC3BC" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export default function ForgotPasswordPage() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handleRequestReset = async (e) => {
    e.preventDefault();
    if (!email.trim()) return setError('Email is required');
    setLoading(true); setError('');
    try {
      await passwordResetAPI.forgot(email.trim());
      setSent(true);
    } catch(e) {
      setError(e.response?.data?.message || 'Failed to send reset request.');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background:'var(--bg)' }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-2">
            <LogoIc />
            <h1 className="text-2xl font-bold" style={{ color:'var(--text)' }}>Q-Lana TMS</h1>
          </div>
          <p className="text-sm" style={{ color:'var(--text-secondary)' }}>Reset your password</p>
        </div>

        <div className="card p-8">
          {!sent ? (
            <form onSubmit={handleRequestReset} className="space-y-5">
              <div>
                <h2 className="text-lg font-semibold mb-1" style={{ color:'var(--text)' }}>Forgot password?</h2>
                <p className="text-sm" style={{ color:'var(--text-secondary)' }}>
                  Enter your account email and we will send you a link to set a new password.
                </p>
              </div>
              <div>
                <label className="label">Email address</label>
                <input type="email" className="input" value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com" autoFocus/>
              </div>
              {error && <p className="text-sm text-red-500">{error}</p>}
              <button type="submit" disabled={loading}
                className="btn-primary w-full flex items-center justify-center gap-2">
                {loading && <span className="w-4 h-4 border border-white/30 border-t-white rounded-full animate-spin"/>}
                Send Reset Link
              </button>
              <p className="text-center text-sm" style={{ color:'var(--text-secondary)' }}>
                Remembered it? <Link to="/login" className="text-brand-500 hover:underline font-medium">Sign in</Link>
              </p>
            </form>
          ) : (
            <div className="text-center space-y-4 py-4">
              <div className="text-5xl">📬</div>
              <h2 className="text-lg font-semibold" style={{ color:'var(--text)' }}>Check your email</h2>
              <p className="text-sm" style={{ color:'var(--text-secondary)' }}>
                If an account exists for <strong>{email.trim()}</strong>, a reset link is on its way.
                It expires in 1 hour. Check your spam folder if it does not arrive.
              </p>
              <Link to="/login" className="btn-primary inline-block px-8">Back to sign in</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
